import React from 'react';
import { makeStyles } from '@mui/styles';
import { ListItemIcon, ListItemText, ListItem, Theme } from '@mui/material';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

const useStyles = makeStyles<Theme>(theme => ({
  listItemText: {
    fontSize: 14,
  },
  listItem: {
    color: `${theme.palette.primary.contrastText}!important`,
  },
  listItemIcon: {
    color: `${theme.palette.primary.contrastText}!important`,
  },
}));

interface SidebarItemMoreProps {
  text: string;
  icon: React.ReactElement;
  handleClick(): void;
}

const SidebarItemMore: React.FC<SidebarItemMoreProps> = ({ icon, text, handleClick }) => {
  const classes = useStyles();

  return (
    <ListItem className={classes.listItem} onClick={handleClick} button>
      <ListItemIcon className={classes.listItemIcon}>{icon}</ListItemIcon>
      <ListItemText color="inherit" classes={{ primary: classes.listItemText }} primary={text} />
      <ChevronRightIcon color="inherit" />
    </ListItem>
  );
};

export default SidebarItemMore;
